export const config = {
  theme: 'silver',
  plugins: [
    'pagebreak',
    'table',
    'save',
    'hr',
    'image',
    'autoresize',
    'link',
    'insertdatetime',
    'preview',
    'media',
    'searchreplace',
    'print',
    'paste',
    'directionality',
    'fullscreen',
    'noneditable',
    'visualchars',
    'nonbreaking',
    'template',
    'autosave',
    'code',
    'lists',
  ].join(','),
  language: 'da',
  browser_spellcheck: true,
  forced_root_block: 'p',
  contextmenu: ['cut', 'copy', 'paste', '|', 'link', 'image', 'inserttable', '|', 'cell', 'row', 'column', 'deletetable'].join(','),
  font_formats: [
    'Arial=arial,helvetica,sans-serif',
    'Arial Black=arial black,avant garde',
    'Courier New=courier new,courier',
    'Helvetica=helvetica',
    'Times New Roman=times new roman,times',
    'Verdana=verdana,geneva',
  ].join(';'),
  autosave_retention: `${60 * 24 * 7}m`,
  autosave_restore_when_empty: false,
  autosave_ask_before_unload: false,
  menubar: false,
  elementpath: false,
  paste_data_images: true,
  fontsize_formats: ['8pt', '10pt', '12pt', '14pt', '16pt', '18pt', '20pt', '22pt', '24pt', '26pt', '28pt', '30pt', '32pt', '34pt', '36pt'].join(' '),
  toolbar1: [
    'formatselect',
    'fontselect',
    'fontsizeselect',
    'pastetext',
    '|',
    'bold',
    'italic',
    'underline',
    'strikethrough',
    '|',
    'alignleft',
    'aligncenter',
    'alignright',
    'alignjustify',
    '|',
    'bullist',
    'numlist',
    '|',
    'outdent',
    'indent|',
    'removeformat',
    'code',
    'undo',
    'redo',
  ].join(' | '),
};
